<template>
  <!-- MBR106 Wallet Balance card — the Activity › Wallet summary card (MBR049),
       shared so every screen showing the balance looks the same -->
  <section class="mbr-wallet">
    <span class="mbr-wallet__ring mbr-wallet__ring--a" aria-hidden="true"></span>
    <span class="mbr-wallet__ring mbr-wallet__ring--b" aria-hidden="true"></span>
    <div class="mbr-wallet__row">
      <div class="mbr-wallet__main">
        <span class="mbr-wallet__eyebrow mbr-wallet__eyebrow--peach">{{ label || $t('reward.wallet_balance') }}</span>
        <div class="mbr-wallet__value">{{ amount }}</div>
      </div>
      <!-- optional right-hand column, like PENDING on Activity -->
      <div v-if="$slots.side" class="mbr-wallet__side">
        <slot name="side"></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "MbrWalletCard",
  props: {
    amount: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.mbr-wallet {
  position: relative;
  overflow: hidden;
  padding: 20px;
  background: var(--mbr-color-primary);
  border-radius: var(--mbr-radius-xl);
  color: var(--mbr-color-on-primary);
  box-shadow: 0 10px 15px -3px rgba(var(--mbr-color-primary-rgb), 0.2), 0 4px 6px -4px rgba(var(--mbr-color-primary-rgb), 0.2);
}

.mbr-wallet__ring {
  position: absolute;
  border: 1px solid rgba(var(--mbr-color-surface-rgb), 0.1);
  border-radius: var(--mbr-radius-full);
  pointer-events: none;
}

.mbr-wallet__ring--a {
  right: -32px;
  bottom: -32px;
  width: 144px;
  height: 144px;
}

.mbr-wallet__ring--b {
  right: 24px;
  bottom: -56px;
  width: 176px;
  height: 176px;
  border-color: rgba(var(--mbr-color-surface-rgb), 0.05);
}

.mbr-wallet__row {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.mbr-wallet__main {
  min-width: 0;
}

.mbr-wallet__side {
  flex: none;
  text-align: right;
}

.mbr-wallet__eyebrow,
:slotted(.mbr-wallet__eyebrow) {
  display: block;
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(var(--mbr-color-surface-rgb), 0.6);
}

.mbr-wallet__eyebrow--peach {
  color: var(--mbr-color-peach);
}

.mbr-wallet__value {
  margin-top: 2px;
  font-family: var(--mbr-font-headline);
  font-size: 26px;
  font-weight: 800;
  line-height: 32px;
  letter-spacing: -0.02em;
  color: var(--mbr-color-on-primary);
  overflow-wrap: anywhere;
}

:slotted(.mbr-wallet__small) {
  margin-top: 2px;
  font-family: var(--mbr-font-headline);
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: rgba(var(--mbr-color-surface-rgb), 0.8);
  white-space: nowrap;
}
</style>
